import { IFilterElement } from "@saleor/components/Filter";
import { findValueInEnum, maybe } from "@saleor/misc";
import { MallInput, SmopStatusEnum } from "@saleor/types/globalTypes";

import {
  createFilterTabUtils,
  createFilterUtils,
  getSingleEnumValueQueryParam
} from "../../../utils/filters";
import {
  MallFilterKeys,
  MallListUrlFiltersOpts
} from "../../components/MallListPage/filters";
import {
  MallListUrlFilters,
  MallListUrlFiltersEnum,
  MallListUrlQueryParams
} from "../../urls";
export const MALL_FILTERS_KEY = "mallFilters";

export function getFilterOpts(
  params: MallListUrlFilters
): MallListUrlFiltersOpts {
  return {
    status: {
      active: maybe(() => params.status !== undefined, false),
      value: maybe(() => findValueInEnum(params.status, SmopStatusEnum))
    }
  };
}

export function getFilterVariables(params: MallListUrlFilters): MallInput {
  return {
    search: params.query,
    status: maybe(() => findValueInEnum(params.status, SmopStatusEnum))
  };
}

export function getFilterQueryParam(
  filter: IFilterElement<MallFilterKeys>
): MallListUrlFilters {
  const { name } = filter;

  switch (name) {
    case MallFilterKeys.status:
      return getSingleEnumValueQueryParam(
        filter,
        MallListUrlFiltersEnum.status,
        SmopStatusEnum
      );
  }
}

export const {
  deleteFilterTab,
  getFilterTabs,
  saveFilterTab
} = createFilterTabUtils<MallListUrlFilters>(MALL_FILTERS_KEY);

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  MallListUrlQueryParams,
  MallListUrlFilters
>(MallListUrlFiltersEnum);
